var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFreight3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 322 242",
    enableBackground: "new 0 0 322 242",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "222.3,154.7 222.3,194.1 68.3,194.1  68.3,120.5 200.6,120.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "222.3,154.7 222.3,194.1 165.1,194.1  165.1,120.5 200.6,120.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "215.6,146.9 215.6,185.4 171.8,185.4  171.8,129.1 203.2,129.1  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 88.4,
    y1: 137,
    x2: 88.4,
    y2: 177.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 105,
    y1: 137,
    x2: 105,
    y2: 177.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 121.6,
    y1: 137,
    x2: 121.6,
    y2: 177.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 138.2,
    y1: 137,
    x2: 138.2,
    y2: 177.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 193.7,
    y1: 129.1,
    x2: 193.7,
    y2: 185.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4,
    y: 129.1,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 86.1,
    height: 56.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M261.9,105.1c-10.2-1.3-20.1-8.9-24.2-12.5 c-1.2-1-2.9-1-4,0c-4.1,3.6-14,11.2-24.2,12.5c-1.6,0.2-2.8,1.6-2.8,3.2c1.3,31.1,21.7,44.8,27.5,48c0.9,0.5,2.1,0.5,3,0 c5.8-3.2,26.2-16.9,27.5-48C264.8,106.7,263.6,105.3,261.9,105.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 60.5565 325.1692)",
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 235.7,
    cy: 124.3,
    rx: 14.9,
    ry: 14.9
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "245,122 238,122 238,115 233,115  233,122 226,122 226,127 233,127 233,134 238,134 238,127 245,127  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFreight3);
export default __webpack_public_path__ + "static/media/logo-freight-3.876828791da9f5018d716f1008f80db2.svg";
export { ForwardRef as ReactComponent };